var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_316_884)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0799 22.2224C47.1168 19.2592 42.3157 19.2592 39.3526 22.2224L36.1519 25.423C33.9575 27.6174 33.3915 30.8111 34.4397 33.5227L36.4664 31.496C36.2428 29.9586 36.725 28.3442 37.899 27.1701L41.0997 23.9695C43.0984 21.9707 46.3411 21.9707 48.3328 23.9695C50.3315 25.9612 50.3315 29.2038 48.3328 31.2025L45.1321 34.4032C43.958 35.5773 42.3437 36.0595 40.8062 35.8358L38.7866 37.8625C41.4981 38.9108 44.6918 38.3377 46.8792 36.1503L50.0799 32.9496C51.5614 31.4681 52.3022 29.5253 52.3022 27.5825C52.3022 25.6467 51.5614 23.7039 50.0799 22.2224Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8358 40.8047C36.0594 42.3422 35.5772 43.9565 34.4032 45.1306L31.2025 48.3313C29.2038 50.33 25.9611 50.33 23.9694 48.3313C21.9707 46.3396 21.9707 43.0969 23.9694 41.0982L27.1702 37.8975C28.3442 36.7235 29.9585 36.2413 31.496 36.4649L33.5156 34.4382C30.8041 33.39 27.6104 33.963 25.423 36.1504L22.2223 39.3511C19.2592 42.3142 19.2592 47.1153 22.2223 50.0784C25.1854 53.0415 29.9865 53.0415 32.9496 50.0784L36.1503 46.8777C37.6319 45.3961 38.3726 43.4534 38.3726 41.5175C38.3726 40.5881 38.2049 39.6586 37.8625 38.7781L35.8358 40.8047Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1828 43.1177C29.8397 43.7676 30.8949 43.7676 31.5518 43.1177L35.3815 39.2881L37.4641 37.2055L39.2881 35.3815L43.1177 31.5518C43.4462 31.2234 43.6069 30.7971 43.6069 30.3638C43.6069 29.9375 43.4462 29.5112 43.1177 29.1828C42.4608 28.5328 41.4056 28.5328 40.7487 29.1828L29.1828 40.7486C28.5328 41.4055 28.5328 42.4608 29.1828 43.1177Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_884",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralStep2);
export default __webpack_public_path__ + "static/media/Referral-Step-2.ebc6c714f1da325080151437511cbb31.svg";
export { ForwardRef as ReactComponent };